"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var css = require("./index.scss");
//@ts-ignore
require("../theme.ts");
var Tree = /** @class */ (function (_super) {
    __extends(Tree, _super);
    function Tree() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._preSelected = null;
        _this.toggle = function (id, open, node) {
            node.close = open;
            _this.fire('toggle', { node: node, id: id, open: open });
            _this.update(true);
        };
        _this._check = function (node, state) {
            if (node.disabled)
                return;
            if (!node.children) {
                node.checked = !node.checked;
            }
            else {
                _this.checkAll(node, state !== 'checked');
            }
            _this.update(true);
            _this.fire('check', { node: node, id: node.id, checked: !node.checked, state: state });
        };
        _this.onNodeClick = function (node) {
            var pre = _this.getNodeById(_this._preSelected, _this.props.node);
            if (pre) {
                pre.selected = false;
            }
            node.selected = true;
            _this.update(true);
            _this.fire('nodeclick', { node: node, id: node.id, pre: _this._preSelected });
        };
        return _this;
    }
    Tree.prototype.checkAll = function (node, checked) {
        var _this = this;
        node.children && node.children.forEach(function (child) {
            child.checked = checked;
            _this.checkAll(child, checked);
        });
    };
    Tree.prototype.getNodeById = function (id, node) {
        if (node.id === id)
            return node;
        if (node.children) {
            for (var i = 0, len = node.children.length; i < len; i++) {
                var child = node.children[i];
                var target = this.getNodeById(id, child);
                if (target) {
                    return target;
                }
            }
        }
    };
    Tree.prototype.renderNode = function (node) {
        var _this = this;
        if (node.selected) {
            this._preSelected = node.id;
        }
        var state;
        if (this.props.checkbox && node.children && node.children.length > 0) {
            state = this._isChecked(node, { checked: 0, unchecked: 0 }, true);
        }
        return omi_1.h("ul", null,
            omi_1.h("li", { class: omi_1.classNames('tree-item', {
                    'close': node.close
                }) },
                node.children && node.children.length > 0 && omi_1.h("svg", { onClick: function (_) { return _this.toggle(node.id, !node.close, node); }, viewBox: "0 0 1024 1024", class: "arrow", "data-icon": "caret-down", width: "1em", height: "1em", fill: "currentColor", "aria-hidden": "true", focusable: "false" },
                    omi_1.h("path", { d: "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" })),
                this.props.checkbox && omi_1.h("span", { onClick: function (_) { return _this._check(node, state); }, class: omi_1.classNames('mdc-tree-checkbox', {
                        'mdc-tree-checkbox-disabled': node.disabled,
                        'mdc-tree-checkbox-checked': (node.children && node.children.length > 0) ? state === 'checked' : node.checked,
                        'mdc-tree-checkbox-indeterminate': (node.children && node.children.length > 0) ? state === 'indeterminate' : false
                    }) },
                    omi_1.h("span", { class: "mdc-tree-checkbox-inner" })),
                omi_1.h("span", { onClick: function (_) { return _this.onNodeClick(node); }, class: omi_1.classNames('mdc-tree-title', {
                        'selected': node.selected
                    }) },
                    node.icon && omi_1.h("i", { class: 'material-icons' }, node.icon),
                    omi_1.h("span", { class: 'text' }, node.title)),
                omi_1.h("div", { class: 'children', style: "height: " + (node.close ? 0 : (node.children ? (this._getChildCount(node)) * 32 : 0)) + "px;" },
                    " ",
                    node.children && node.children.length > 0 && node.children.map(function (_) { return _this.renderNode(_); }))));
    };
    Tree.prototype._isChecked = function (node, obj, tag) {
        if (!node.children)
            return;
        for (var i = 0, len = node.children.length; i < len; i++) {
            var child = node.children[i];
            if (child.children && child.children.length === 0 || !child.children) {
                if (!child.disabled) {
                    if (child.checked) {
                        obj.checked++;
                    }
                    else {
                        obj.unchecked++;
                    }
                }
            }
            if (obj.unchecked && obj.checked) {
                break;
            }
            this._isChecked(child, obj, false);
        }
        if (tag) {
            if (obj.unchecked && obj.checked) {
                return 'indeterminate';
            }
            if (obj.unchecked === 0)
                return 'checked';
            return 'unchecked';
        }
    };
    Tree.prototype._getChildCount = function (node) {
        var _this = this;
        var count = 0;
        if (node.children && !node.close) {
            count += node.children.length;
            node.children.forEach(function (child) {
                count += _this._getChildCount(child);
            });
        }
        return count;
    };
    Tree.prototype.render = function (props) {
        return this.renderNode(props.node);
    };
    Tree.css = css;
    Tree.propTypes = {
        checkbox: Boolean,
        node: Object
    };
    Tree = __decorate([
        omi_1.tag('m-tree')
    ], Tree);
    return Tree;
}(omi_1.WeElement));
exports.default = Tree;
